import { ProjectActions } from "../../reducers/project/actionsNames";
import { Category, IAttributes, IProject } from "../../reducers/project";

export default (id: string, count: number) => ({
  type: ProjectActions.ChangeProjectCount,
  id,
  count,
});
